/**
 * Route copy for `src/routes/notifications` (keys: `routes.notifications.<file>.<key>`).
 *
 * `fr` is the source; `en` and `ar` are typed against it, so a missing or extra
 * key fails `tsc` (and parity.test.ts). Keys are referenced from the route files
 * through `t()` / `tr()` — edit values freely, never rename a key without its call site.
 *
 * Locale file: en (typed against ./fr). One file per locale so
 * every non-default locale is a separate, lazily-loaded chunk.
 */

import type { Catalog } from './fr';

const en: Catalog = {
  notificationBell: {
    all: 'All',
    aiTeam: 'AI team',
    collaboration: 'Collaboration',
    publishing: 'Publishing',
    notificationsUnreadcountUnread: 'Notifications — {{unreadCount}} unread',
    notifications: 'Notifications',
    markAllAsRead: 'Mark all as read',
    notificationPreferences: 'Notification preferences',
    filterNotifications: 'Filter notifications',
    loading: 'Loading…',
    notificationsUnavailableForNow: 'Notifications unavailable for now.',
    noNotification: 'No notification.',
    noNotificationInThisFilter: 'No notification in this filter.',
    priority: 'Priority',
    clearAll: 'Clear all',
    clearAllTitle: 'Clear all notifications?',
    clearAllMessage: 'All your notifications will be permanently deleted. This cannot be undone.',
    deleteNotification: 'Delete notification "{{title}}"',
    deleteNotificationShort: 'Delete',
    unread: 'Unread',
  },
  notificationPrefs: {
    aiTeam: 'AI team',
    collaboration: 'Collaboration',
    publishing: 'Publishing',
    alsoReceiveByEmail: 'Also receive by email',
    labelEmailV: '{{label}} — email {{v}}',
    enabled: 'enabled',
    disabled: 'disabled',
    notificationPreferences: 'Notification preferences',
    resetShowEverything: 'Reset (show everything)',
    chooseTheNotificationTypesToReceive: 'Choose the notification types to receive. This setting is saved on your account: once disabled, a notification type is no longer sent, neither in the bell nor by email.',
    email: '✉️ Email',
  },
};

export default en;
